import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const DaysOffMenuIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M11.6605 11.1312C10.5767 11.1309 9.5081 10.8767 8.54036 10.3888C7.57262 9.90098 6.73268 9.19311 6.08794 8.322C5.4432 7.45089 5.0116 6.44079 4.82776 5.37274C4.64392 4.30469 4.71297 3.20842 5.02936 2.17188C3.97916 2.65594 3.06678 3.39511 2.37535 4.32201C1.68391 5.24892 1.2354 6.33411 1.07068 7.47871C0.905951 8.62331 1.03025 9.79093 1.43225 10.8752C1.83425 11.9595 2.50117 12.9259 3.37225 13.6865C4.24333 14.447 5.29087 14.9776 6.41945 15.2297C7.54802 15.4818 8.72174 15.4475 9.83367 15.13C10.9456 14.8124 11.9604 14.2217 12.7856 13.4116C13.6108 12.6015 14.2202 11.5978 14.5583 10.4919C13.6502 10.9129 12.6614 11.1311 11.6605 11.1312Z"
        stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      <path d="M7.92578 2.60156H11.1258" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.52734 1V4.2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.7266 5.80078H14.8599" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.793 4.73438V6.86771" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgIcon>
  );
};


